import type {VersionInfo} from './app/utils.class';

export const compiledVersion: VersionInfo = {"buildNumber":"D. van der Steen B.V_acceptance_2026-11-04_11-0-17","buildId":"24875","environment":"trackline-acceptance","datetime":"2026-11-04T10:06:42.117Z","checkForUpdates":true}